import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "relieve",
  "use": "relieve-usage",
  "viewBox": "0 0 90.61 99.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 90.61 99.9\" id=\"relieve\"><title>relieve</title><path d=\"M78.7 9.4H66.2A12.09 12.09 0 0 0 54.5 0H36.3a12.26 12.26 0 0 0-11.7 9.4H12.1A12.3 12.3 0 0 0 0 21.9V25h3v3.1h6v59.3a12.3 12.3 0 0 0 12.1 12.5h48.4a12.3 12.3 0 0 0 12.1-12.5V28.2h6V25h3v-3.1A12.07 12.07 0 0 0 78.7 9.4zM36.3 6.3h18.2a6.06 6.06 0 0 1 5.2 3.1H31.1a6.19 6.19 0 0 1 5.2-3.1zm39.3 81.1a6.13 6.13 0 0 1-6 6.2H21.2a6.57 6.57 0 0 1-6.5-6.2l.4-59.3h60.5v59.3zm1.9-65.5H6.1a6.15 6.15 0 0 1 6.1-6.2h66.5a6.13 6.13 0 0 1 6 6.2z\" /><path d=\"M43.5 60c5.5 0 17.1 2.6 17.1 10.2 0 6.8.4 9.4-1.7 15.4 5.5-6 8.9-12.4 8.9-19.2 0-16.6-20.5-20-24.3-20V36.1L22.2 54l21.3 17.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/relieve.svg
// module id = aVl7
// module chunks = 6